import moment from "moment-timezone";

export function getAttendanceDateTime({
  attendance,
  timezone = undefined,
}: {
  attendance: {
    date: Date;
    time?: string;
    startTime?: string;
  };
  timezone?: string;
}) {
  if (!attendance) {
    return new Date();
  }

  if (!attendance.date) {
    return null;
  }

  const attendanceTime = attendance.startTime
    ? moment(attendance.startTime, "HH:mm")
    : moment(attendance.time, "HH:mm");
  const attendanceServer = moment.utc(attendance.date);
  let attendanceDate = moment.tz(
    attendanceServer.format("YYYY-MM-DD"),
    timezone
  );

  // console.log("attendanceServer", attendanceServer.format());
  // console.log("attendanceDate", attendanceDate.format());
  // console.log("attendanceTime", attendanceTime.format());
  // console.log("timezone", timezone);

  attendanceDate = attendanceDate.set({
    hour: attendanceTime.get("hour"),
    minute: attendanceTime.get("minute"),
    second: attendanceTime.get("second"),
  });

  return attendanceDate.toDate();
}
